<template>
    <div>
        <div v-if="(publications && publications.length) || product.burrito" class="row mt-3">
            <div v-if="resourceImages.length" class="product-images d-flex">
                <b-carousel
                    id="carousel-1"
                    v-model="slide"
                    :interval="6000"
                    controls
                    indicators
                    background="#ababab"
                    img-width="1024"
                    img-height="480"
                    style="text-shadow: 1px 1px 2px #333;"
                    class="mx-2"
                >
                    <b-carousel-slide v-for="(image, index) in resourceImages" :key="index">
                        <template #img>
                            <img :src="`//cdn.studiesweekly.com/${image}`" class="w-100" @click="selectImage(image)">
                        </template>
                    </b-carousel-slide>
                </b-carousel>
            </div>

            <!-- Loading Icons -->
            <div v-else class="product-placeholder-images d-flex">
                <div v-for="(image, index) in 20" :key="index" class="product-placeholder-image h-100">
                    <content-placeholders :rounded="true">
                        <content-placeholders-img />
                    </content-placeholders>
                </div>
            </div>
        </div>

        <b-modal id="image-modal" size="xl" centered hide-footer>
            <template v-slot:modal-header>
                <button
                    type="button"

                    class="ml-auto close"

                    aria-label="Close"

                    @click="closeImageModal"
                >
                    <font-awesome-icon :icon="['fas', 'times']" />
                </button>
            </template>
            <template v-slot:default>
                <div class="d-flex product-images bg-light border-top p-3">
                    <b-img
                        fluid-grow
                        v-for="(image, index) in publicationResources[product.sku]"
                        :key="index"
                        :src="'//cdn.studiesweekly.com/' + image"
                        class="img-fluid h-100 border"
                        :class="{'border-primary': (image == selectedImage)}"
                        @click.prevent="selectImage(image)"
                    />
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "ProductResources",
    props: ['product', 'publications'],
    computed: {
        ...mapState({
            publicationResources: state => state.stateData.publicationResources,
            pageResources: state => state.stateData.pageResources,
            globalResources: state => state.stateData.globalResources,
        }),
        resourceImages() {
            let resources =  Object.assign({},this.publicationResources);
            let productImages = [];
            if (resources.hasOwnProperty(this.product.sku)) {
                productImages = resources[this.product.sku];
                productImages = productImages.filter(img => img.match(/^(.*)\/OStore-/) == null);
            }
            productImages.sort();
            this.pageResources.sort();
            this.globalResources.sort();

            let allImages = [...productImages, ...this.pageResources, ...this.globalResources];
            // console.log(allImages);
            return allImages;
        },
        cover() {
            if (this.product.cover_url) {
                return this.product.cover_url;
            }
            let productCover = null

            let sku = null

            if (this.product.sku) {
                let sku2 = this.product.sku.replace(/-(?:SS|SN)-(?:EN|ES)-V[0-9]{1,2}/, "")
                sku2 = sku2.replace(/V[0-9]{2}/, "")
                sku = this.product.sku.replace(/V[0-9]{2}/, "")

                productCover = 'store/products/sku/' + sku + '/OStore-' + sku2 + '-SE-Week1-Page1.jpg'
            }

            return productCover;
        }
    },
    data: () => ({
        selectedImage: null,
        slide: 0
    }),
    methods: {
        showImageModal (source) {
            console.log("show image")
            this.selectImage(source)

            this.$bvModal.show("image-modal")
        },
        closeImageModal () {
            this.$bvModal.hide("image-modal")
        },
        selectImage(source) {
            this.$bvModal.show("image-modal")
        }

    }
}
</script>

<style lang="scss" scoped>

.product-placeholder-images,
.product-images {
    overflow-x: auto;
    overflow-y: hidden;
    height: calc(400px + 2rem); // 1rem padding top and bottom
}

.product-images img {
    cursor: pointer;
}

.product-images img + img {
    margin-left: .5rem;
}

.product-images::-webkit-scrollbar {
    -webkit-appearance: none;
}

.product-images::-webkit-scrollbar:vertical {
    width: 11px;
}

.product-images::-webkit-scrollbar:horizontal {
    height: 11px;
}

.product-images::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
}
</style>